import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { KitchenCollections } from 'landings';
import { RemoteProps } from './widgets-types';

export const KitchenCollectionsRemote: React.FC<RemoteProps> = ({ router, store }) => (
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <KitchenCollections />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
